module.exports = __webpack_public_path__ + "static/media/IMG_3490_sm.f30889fa.jpg";